module.exports = __webpack_public_path__ + "img/01.440caab2.jpg";